// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "842") return "media/styles/842.f48c99f4.css";
  // return url for filenames based on template
  return "media/styles/" + chunkId + "." + "07bc9989" + ".chunk.css"
}